import { computed, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { oofDtos } from '@vectronic/openApi-customer';
import { merge, Subject, switchMap } from 'rxjs';
import { AddressesRestService } from './REST/addresses.rest.service';

interface AddressesState {
  addresses: oofDtos.UserAddress[];
  loaded: boolean;
  error: string | null;
}
@Injectable({ providedIn: 'root' })
export class AddressesService {
  private addressesRestService = inject(AddressesRestService);

  // state
  private state = signal<AddressesState>({
    addresses: [],
    loaded: false,
    error: null,
  });

  // selectors
  addresses = computed(() => this.state().addresses);

  // sources
  refreshAddresses$ = new Subject<void>();
  #addressesLoaded$ = this.addressesRestService.getOwnAddresses();
  #addressesRefreshed$ = this.refreshAddresses$.pipe(
    switchMap(() => this.addressesRestService.getOwnAddresses()),
  );

  constructor() {
    // reducers
    merge(this.#addressesLoaded$, this.#addressesRefreshed$)
      .pipe(takeUntilDestroyed())
      .subscribe((addresses) =>
        this.state.update((state) => ({ ...state, addresses, loaded: true })),
      );

    // effects
  }
}
